module.exports = __webpack_public_path__ + "img/ps_old.c53105f7.png";